const top_pickup = () => {
	const pickup_slide = document.querySelector('.p-top__pickup__slide');
	if(pickup_slide !== null){
		const swiper = new Swiper(pickup_slide, {
			slidesPerView: 'auto',
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			speed: 800,
			pagination: {
				el: '.p-top__pickup__slide__pagination'
			},
			breakpoints: {
				768: {
					navigation: {
						prevEl: '.p-top__pickup__slide__arrow--prev',
						nextEl: '.p-top__pickup__slide__arrow--next',
					},
				}
			}
		});
	}
}